export const TWILIO_SID_LENGTH = 34

interface TwilioSidRule {
  label: string
  prefix: string
  required: boolean
}

export const TWILIO_SID_RULES = {
  accountSid: { label: 'Account SID', prefix: 'AC', required: true },
  messagingServiceSid: { label: 'Messaging Service SID', prefix: 'MG', required: false },
  phonicTrunkSid: { label: 'Trunk SID', prefix: 'TK', required: false },
} satisfies Record<string, TwilioSidRule>

export const validateTwilioSid = (value: string, rule: TwilioSidRule): string | null => {
  const sid = value.trim()
  if (!sid) return rule.required ? `${rule.label} is required` : null
  if (!sid.startsWith(rule.prefix)) return `${rule.label} must start with "${rule.prefix}"`
  if (sid.length !== TWILIO_SID_LENGTH) {
    return `${rule.label} must be ${TWILIO_SID_LENGTH} characters (currently ${sid.length})`
  }
  if (!/^[0-9a-zA-Z]+$/.test(sid)) return `${rule.label} may only contain letters and numbers`
  return null
}

export const truncateSid = (sid: string, visibleChars = 8): string =>
  sid.length > visibleChars ? `${sid.slice(0, visibleChars)}…` : sid
